import { useRef, useEffect } from 'react'
import { motion, useMotionValue, useTransform } from 'framer-motion'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

/* Centreline stroke path from Path-02.svg */
const CENTERLINE =
  'M947.87,222.73c79.53,44.05,194.53,168.64,228.83,241.38,66.73,141.51,52.39,205.84,12.62,309.22-67.22,141.28-176.26,221.22-328.16,258.74-75.53,18.7-252.43-44.17-398.75,214.92s123.55,438.96,228.36,460.32,348.08,19.49,454.37,31.55c168.08,51.41,271.36,170.39,239.81,403.88-88.35,328.16-305.1,306.63-542.72,353.4-63.91,12.57-196.93-12.69-303.43-21.69-48.17-4.07-214.05-54.44-214.05-199.45s139.93-212.57,258.74-195.36c118.2,17.12,171.17,17.26,189.32,180.5,20.04,180.23-187.02,338.44-269.26,431.64-126.21,143.04,0,311.46,0,311.46,122.02,155.53,347.7,149.56,453.97,141.84,189.8-13.79,318.85-1.06,390.87,13.84,101.77,37.71,173.29,75.58,227.99,172.34,90.61,193.31,91.95,339.55-8.41,466.99-107.37,168.92-385.15,157.59-584.79,143.04-63.59-4.61-151.46,12.62-197.73,29.45-59.87,21.77-147.25,71.52-155.84,182.84.18,94.83-11.67,212.23-12.74,304.33'

export default function SnakePath() {
  const containerRef = useRef<HTMLDivElement>(null)
  const scrollProgress = useMotionValue(0)
  const pathLength = useTransform(scrollProgress, [0, 0.85], [0, 1])
  const pathOpacity = useTransform(scrollProgress, [0, 0.05], [0, 1])

  useEffect(() => {
    const startAnchor = document.querySelector('[data-snake-start]')
    const endAnchor = containerRef.current
    if (!startAnchor || !endAnchor) return

    const st = ScrollTrigger.create({
      trigger: startAnchor,
      start: 'top top',
      endTrigger: endAnchor,
      end: 'bottom top',
      onUpdate: (self) => scrollProgress.set(self.progress),
    })

    return () => st.kill()
  }, [scrollProgress])

  return (
    <div ref={containerRef} className="pointer-events-none absolute inset-0 hidden md:block">
      <svg
        viewBox="0 0 1850 4550"
        fill="none"
        className="absolute left-1/2 -top-[72vw] h-[320vw] w-[200vw] max-w-none -translate-x-1/2 sm:w-[160vw] md:w-[130vw] lg:w-[100vw]"
        preserveAspectRatio="none"
      >
        <motion.path
          d={CENTERLINE}
          fill="none"
          stroke="#ffd625"
          strokeWidth="363"
          strokeLinecap="round"
          style={{ pathLength, opacity: pathOpacity }}
        />
      </svg>
    </div>
  )
}
